/**
 * Resolves an object path and returns the corresponding value.
 *
 * @param {object} object - The object to resolve the path for.
 * @param {string} path - The string path to find in the object.
 *
 * @return {any} - The value at the object path, or null if path doesn't exist.
 */
export function resolveObjectPath(object, path) {
  if (!path || typeof path !== 'string' || typeof object !== 'object' || object === null) {
    return null;
  }
  if (object.hasOwnProperty(path)){
    return object[path];
  }
  return path.split('.').reduce((a, c) => (a && a.hasOwnProperty(c) ? a[c] : null), object);
}
